import { createTheme } from '@mui/material/styles';

// AIM (Always Inventing More) theme - Professional tech company aesthetic
const aimTheme = createTheme({
  palette: {
    primary: {
      main: '#1f6fb2', // AIM Blue from logo
      light: '#4a8fc7',
      dark: '#155a8a',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#2f3e4e', // AIM Dark from logo
      light: '#4a5a6a',
      dark: '#1c2a35',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#0a0f1a',
      paper: '#111827',
    },
    text: {
      primary: '#f8fafc',
      secondary: '#94a3b8',
    },
    divider: 'rgba(148, 163, 184, 0.12)',
  },
  typography: {
    fontFamily: '"DM Sans", "Segoe UI", Roboto, sans-serif',
    h1: {
      fontFamily: '"Sora", "Segoe UI", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"Sora", "Segoe UI", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontFamily: '"Sora", "Segoe UI", sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Sora", "Segoe UI", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Sora", "Segoe UI", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Sora", "Segoe UI", sans-serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"DM Sans", "Segoe UI", sans-serif',
      fontWeight: 400,
      lineHeight: 1.75,
    },
    body2: {
      fontFamily: '"DM Sans", "Segoe UI", sans-serif',
      fontWeight: 400,
      lineHeight: 1.65,
    },
    button: {
      fontFamily: '"DM Sans", "Segoe UI", sans-serif',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollBehavior: 'smooth',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.25)',
          border: '1px solid rgba(148, 163, 184, 0.08)',
          backdropFilter: 'blur(10px)',
          background: 'linear-gradient(135deg, rgba(17, 24, 39, 0.9) 0%, rgba(17, 24, 39, 0.7) 100%)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: 'none',
          fontWeight: 600,
          padding: '10px 24px',
          boxShadow: 'none',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 24px rgba(31, 111, 178, 0.35)',
          },
        },
        contained: {
          background: 'linear-gradient(135deg, #1f6fb2 0%, #155a8a 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #4a8fc7 0%, #1f6fb2 100%)',
          },
        },
        outlined: {
          borderColor: 'rgba(31, 111, 178, 0.5)',
          '&:hover': {
            borderColor: '#1f6fb2',
            backgroundColor: 'rgba(31, 111, 178, 0.08)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundColor: 'rgba(10, 15, 26, 0.85)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(148, 163, 184, 0.08)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            backgroundColor: 'rgba(17, 24, 39, 0.6)',
            '& fieldset': {
              borderColor: 'rgba(148, 163, 184, 0.2)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(31, 111, 178, 0.5)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1f6fb2',
            },
          },
        },
      },
    },
  },
});

export default aimTheme;
